import { CommentItem } from 'Frontend/scripts/models/communityNews.model'
import { FunctionComponent } from 'react'
import { Button } from 'react-bootstrap'
import * as commentService from 'Frontend/scripts/services/comments.services'
import { useTranslation } from 'react-i18next'

interface CommentProps extends CommentItem {
  hasCurrentUserAccessToDeleteComment: boolean
  onPostDeleted: () => void
}

const Comment: FunctionComponent<CommentProps> = ({
  id,
  publishDate,
  userName,
  comment,
  hasCurrentUserAccessToDeleteComment,
  onPostDeleted,
}) => {
  const { t } = useTranslation()

  const deleteComment = () => {
    commentService.deleteComment(id).then(() => {
      onPostDeleted()
    })
  }

  return (
    <article className="comments__item">
      <p className="comments__text">{comment}</p>
      <span className="comments__date text-muted">
        {userName} {publishDate}
      </span>
      {hasCurrentUserAccessToDeleteComment && (
        <div className="mt-2">
          <Button size="sm" className="gap-2 livstecknet-thread__edit-question" onClick={() => deleteComment()}>
            <span className="fa fa-trash-o"></span>
            {t('delete')}
          </Button>
        </div>
      )}
    </article>
  )
}

export default Comment
